import utils from '../../utils';
import fetch from '../fetch';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const setRefresh = (callback) => {
    DataGrid.refresh = callback
}


const onSelect = (ids) => {
    DataGrid.selections = ids
}

const getSelection =() => {
    return DataGrid.selections;
}

const columns = utils.columns([
    { key: '$index', label: '序号', width: 35 },
    { key: 'orgName', label: '巡课教师所属部门', width: 70 },
    { key: 'employeeName', label: '巡课教师', width: 70 },
    { key: 'employeeCode', label: '巡课教师工号', width: 70},
    { key: 'patrolNum', label: '巡课次数', width: 70 , render:value => `${value}次`},
    { key: 'employeeNum', label: '已巡教师', width: 70 , render:value => `${value}人`},
    { key: 'courseNum', label: '已巡课程', width: 70 , render:value => `${value}门`}
]);

/**
 * @method querySearch
 * @param {object} [keywords]
 * @return {promise}
 */
const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    return fetch.post('/patrol/class/summary/list', keywords)
    .then(response => {
        return response.payload.data;
    })
    .then(data => (Object.assign({
        result: data.dataList || [],
        selects: (data.dataList || []).map(d => ({
            value: d.id,
            checked: false
        })),
        checked: false,
        total: data.total,
        pageIndex: data.pageNum,
        pageSize: data.pageSize,
        notify: (data.dataList || []).length ? '' : '暂无数据...'
    })));
}

/**
 * 数据导出
 * @method multiple
 * @param {object} [keywords]
 * @return {promise}
 */
const exportScore = (keywords) => {
    return fetch.download('/patrol/class/summary/exportScore', keywords, "巡课数据汇总.xls")
}


export default {
    setRefresh,
    onSelect,
    columns,
    querySearch,
    exportScore,
    getSelection
}